/* eslint-disable */
// AppOverlays — the one element App.js renders from every authenticated path.
//
// WHY THIS FILE EXISTS
//   App.js is on the GOV1 LOC grandfather list (Conv #163): it may shrink, never
//   grow. A global notification host has to render above every early return,
//   which means touching that file. Wrapping both overlays in one element makes
//   the edit three RENAMES rather than three additions:
//
//     import line      1 line  -> 1 line
//     element const    1 line  -> 1 line
//     each render site {globalSearchOverlay} -> {appOverlays}, inside the
//                      existing line
//
//   Net delta: zero. App.js ends at exactly the line count it started with.
//
// GlobalSearchMount's props are forwarded verbatim — they are the values that
// genuinely live in App (devs/fields from useAppData, role from useAuthSetup,
// and the two catalog setters), and re-deriving them here would duplicate a
// fetch or re-run side-effect setters. NotificationHost takes NONE: it resolves
// its own user and lets RLS scope its rows, the same way ActivityDrawer does.

import React from 'react';
import ProjectsChooserMount from './projects/ProjectsChooserMount';
import { GlobalSearchMount } from '../globalSearch/GlobalSearchMount';
import { NotificationHost } from './NotificationHost';
import { AnnouncementComposer } from './AnnouncementComposer';
import { NotificationDrawer } from './NotificationDrawer';
import { ImportantBar } from './ImportantBar';
import { CriticalModal } from './CriticalModal';
import { MorningBriefing } from './briefing/MorningBriefing';
import { useNotificationDeepLink } from '../../hooks/useNotificationDeepLink';
import { useCollectionLinkOpen } from '../../hooks/useCollectionLinkOpen';
import { useNamesLinkOpen } from '../../hooks/useNamesLinkOpen';
import { useBookLinkOpen } from '../../hooks/useBookLinkOpen';
import BookMount from '../../portals/book/BookMount';

export function AppOverlays({ fields, role, setSelected, setFBrand }) {
  // P9 — ?n=<notification id> from an announcement email. Consumed HERE for the
  // same reason this file exists: App.js may not grow. It renders nothing; it
  // navigates once, after the shell is up, which is what the open-bridges need.
  useNotificationDeepLink();
  // CLB-077 — the Collection email's button (?tab=collection) opens the Collection, not the portal chooser.
  useCollectionLinkOpen();
  // ORD-NAMES-1 — ?tab=orders&names=1 opens the Orders portal, which then shows the Names department.
  useNamesLinkOpen();
  // ORD-BOOK-1 — ?book=sun-ss2027 opens the Collection Book (Orders access only).
  useBookLinkOpen();
  return (
    <>
      <GlobalSearchMount
        fields={fields}
        role={role}
        setSelected={setSelected}
        setFBrand={setFBrand}
      />
      <ProjectsChooserMount />
      <BookMount />
      <NotificationHost />
      <AnnouncementComposer />
      <NotificationDrawer />
      <ImportantBar />
      <CriticalModal />
      <MorningBriefing />
    </>
  );
}

export default AppOverlays;
